<template>
  <div>
    <CRow :class="isPrint ? 'py-0' : 'py-5'">
      <CCol>
        <Engagement :engagementResultType="engagementResultType" />
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <SMSEngagement :isPrint="isPrint" :campaignResult="campaignResult" />
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <EmailEngagement :isPrint="isPrint" :campaignResult="campaignResult" />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Engagement from './dashboard/Engagement.vue'
import SMSEngagement from './dashboard/SMSEngagement.vue'
import EmailEngagement from './dashboard/EmailEngagement.vue'
export default {
  props: {
    campaignResult: Object,
    isPrint: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Engagement,
    SMSEngagement,
    EmailEngagement,
  },
  computed: {
    engagementResultType() {
      return this.campaignResult?.engagement?.engagementResultType
    }
  }
}
</script>
